<template>

  <div class="login-wrapper df fdc jcfs aic f1 w100p" v-bind:class="{
    'getting-pro': $route.query.pro == 'getpro'
  }">

    <!-- LOGIN INPUTS -->

    <!-- SPLASH -->
    <div class="login-splash df fdc aifs w100p">
      <div class="login-big-text df fdc w100p" v-if="$route.query.auth == 'pro'">
        <div class="df splash-hero splash-hero-2 f1 df aic fdc w100p" v-if="$route.query.pro == 'getpro'">
          <div class="df fdr jcsb aifs f2 w100p mw870">

            <div class="checkout df fdc">
              <h2 class="get-cupwise">Try CupWise Pro <span class="ull">free for 7 Days!</span></h2>
              <div class="df aic">
                <p class="checkout-price">$24.99</p>
                <p class="per-month">&nbsp;per month after</p>
                <!-- <p class="checkout-price checkout-price-2">Try CupWise Pro free for 7 Days</p> -->
                <!-- <span class="df fdc jcc checkout-price-next"> -->
                  <!-- <p>Standard plan</p> -->
                <!-- </span> -->
              </div>
              <p class="first-one-liner">
                ☕ Host your own tastings<br/>
                📱 Integrate into your website<br/>
                📊 Your go-to coffee analysis tool!
              </p>
              <hr class="checkout-line">
                <div class="product-detail f1 df fdc" v-bind:class="{
                  'mb20': !$store.getters['AUTH.email']
                }">
                  <h4>Email</h4>
                    <input v-if="$store.getters['AUTH.email']" class="checkout-input" placeholder="Your Email" :value="$store.getters['AUTH.email']" disabled type="email" name="">
                    <input v-else class="checkout-input" placeholder="Your Email" v-model="otherEmail" type="email" name="">
                </div>
                <!-- <div class="df w100p product-detail-outer">
                  <div class="product-detail f1">
                    <h4>Current Password</h4>
                    <input placeholder="Password" v-model="currentPassword" type="" name="">
                  </div>
                  <div class="product-detail f1">
                  </div>
                </div> -->
                <div v-if="!$store.getters['AUTH.email']" class="df w100p product-detail-outer">
                  <div class="product-detail f1 _s2_1">
                    <h4>Password</h4>
                    <input class="checkout-input" placeholder="Password" v-model="newPassword" type="password" name="">
                  </div>
                  <div class="product-detail f1 _s2_2">
                    <h4>Confirm Password</h4>
                    <input class="checkout-input" placeholder="Confirm Password" v-model="newPasswordConfirm" type="password" name="">
                  </div>
                </div>
              <hr class="checkout-line">
              <div class="df w100p product-detail-outer">
                <div class="product-detail f1 payment-methods">
                  <h4 class="_s1 df aic">
                    <img src="../../static/images/icon-card.svg" class="cc-icon">
                    Payment Information
                  </h4>
                  <!-- <span class="df">
                    <span class="df one-payment-method check-fulfillment aic">
                      <input v-model="checkOutOption"
                      type="checkbox"
                      class="check-fulfillment-box"
                      name=""
                      id="checkoutPaymentMethod">
                      <label for="checkoutPaymentMethod"></label>
                      <p>
                        Credit Card
                      </p>
                    </span>
                    <span class="df one-payment-method check-fulfillment aic">
                      <input v-model="checkOutOptionB"
                      type="checkbox"
                      disabled="true" 
                      class="check-fulfillment-box"
                      name=""
                      id="checkoutPaymentMethod2">
                      <label for="checkoutPaymentMethod2"></label>
                      <img src="../../static/images/icon-paypal.svg">
                      <p>
                        PayPal
                      </p>
                    </span>
                  </span> -->
                  <!-- <input class="checkout-input" placeholder="Password" v-model="newPassword" type="" name=""> -->
                </div>
              </div>
              <!-- Payment method == CC, paypal coming soon -->
              <div class="card-error df" v-if="checkoutError">
                <span class="warning df aic jcc">
                  <img src="../../static/images/icon-warning.svg">
                </span>
                <span class="f1 df fdc jcc card-error-message">
                  <p>Double check your information</p>
                  <p>{{checkoutError.message || '-'}}</p>
                </span>
              </div>
              <div class="cc-inputs df">
                <input class="checkout-input cc-card f3" v-model="checkoutCC" v-mask="'#### #### #### ####'" placeholder="Card Number"></input>
                <input class="checkout-input cc-date f1" v-model="checkoutCCDate" v-mask="'##/##'" placeholder="MM/YY"></input>
                <input class="checkout-input cc-cvv f1" v-model="checkoutCCCVV" v-mask="'###'" placeholder="CVV"></input>
              </div>
              <p v-if="getPlanError" class="get-plan-error">{{getPlanError}}</p>
              <a v-if="activating" class="button-1 w100p checkout-button">Loading plan...</a>
              <a v-else class="button-1 w100p checkout-button" @click="getProPlan()">Activate Free 7-Day Trial</a>
              <p class="checkout-protection"><i class="fal fa-lock stripe-lock"></i>Payments powered by Stripe.</p>
            </div>
            <p class="one-liner-upgrade dn">CupWise Pro lets you host unlimited sessions and host live cuppings for your customers as well as private cuppings for in-house quality control.</p>
            <div class="pricing-plans">
              
              <div class="pricing-plan pricing-plan-2">
                <div class="pricing-plan-header pricing-1">
                  <p class="pricing-plan-header-name">CupWise Pro</p>
                  <hr/>
                  <p class="pricing-plan-header-price">$24.99/month</p>
                  <p class="pricing-plan-header-subheading">Unlimited Cuppings</p>
                </div>
                <!-- <div class="f1"></div> -->
                <div class="pricing-plan-box pricing-plan-single">
                  <span class="pricing-plan-two-liner">
                    <p>Up to 1000 Cuppers</p>
                    <p>Per cupping</p>
                  </span>
                  <span class="pricing-plan-two-liner">
                    <p>30 Coffees</p>
                    <p>Per session</p>
                  </span>
                  <p>Host your own tastings</p>
                  <!-- <p>Chat, video, and more</p> -->
                  <!-- <p>Template Editor</p> -->
                  <p>CupWise template library</p>
                  <p>Cupping statistics</p>
                  <p>Embeddable</p>
                  <p>Live onboarding</p>
                  <p>E-mail support</p>
                  <div class="f1"><br/></div>
                  <p class="try-it-free">Start hosting today!</p>
                  
                  <!-- <div class="f1"></div> -->
                  <!-- <a class="button-1" @click="addQuery('pro', 'getpro')">Get Started</a> -->
                </div>  
              </div>
              

            </div>


          </div>
          <div class="df fdc jcc aic f3">
          </div>
        </div>
        <div class="df splash-hero f1 df fdc w100p" v-else>
          <div class="df fdc jcc f2 auth-message-wrapper w100p _m4">


            <h2 class="line-3">Get CupWise Pro</h2>
            <!-- <p class="line-2 w100p">Host live and offline cupping sessions, embed CupWise into your website or collect scoring data internally.
            </p> -->
            <p class="line-2 w100p">
            CupWise gives you the tools to engage your audience and get breakthrough taste data insights. Host your own tastings, integrate into your website and use CupWise as your go-to cupping tool!</p>
            <!-- <a class="button-1 _button-1" @click="addQuery('auth', 'register')">Get Started</a> -->
          </div>
          <div class="df fdc jcc f2 w100p">

            <div class="pricing-plans">
              
              <div class="pricing-plan curp" @click="addQuery('pro', 'getpro')">
                <div class="pricing-plan-header pricing-1">
                  <p class="pricing-plan-header-name">Pro</p>
                  <hr/>
                  <p class="pricing-plan-header-price">$24.99/month</p>
                  <p class="pricing-plan-header-subheading">Up to 10 Cuppings</p>
                </div>
                <div class="f1"></div>
                <div class="pricing-plan-box highlighted-plan">
                  <span class="pricing-plan-two-liner">
                    <p>Up to 150 Cuppers</p>
                    <p>Per cupping</p>
                  </span>
                  <span class="pricing-plan-two-liner">
                    <p>5 Coffees</p>
                    <p>Per session</p>
                  </span>
                  <p>Host your own tastings</p>
                  <p>Use the Cupwise library</p>
                  <p>Cupping statistics</p>
                  <p>Embeddable</p>
                  <p>Live onboarding</p>
                  <div class="f1"></div>
                  <p class="try-it-free">Try it free for 7 days!</p>
                  <a class="button-1">Get Started</a>
                  <!-- <a class="button-1" @click="goTo('/get/pro')">Get Started</a> -->
                </div>  
              </div>
              
              <div class="pricing-plan">
                <div class="pricing-plan-header pricing-2">
                  <p class="pricing-plan-header-name">Pro+</p>
                  <hr/>
                  <p class="pricing-plan-header-price">$99.99/month</p>
                  <p class="pricing-plan-header-subheading">Up to 50 Cuppings</p>
                </div>
                <div class="f1"></div>
                <div class="pricing-plan-box">
                  <span class="pricing-plan-two-liner">
                    <p>Up to 1000 Cuppers</p>
                    <p>Per cupping</p>
                  </span>
                  <span class="pricing-plan-two-liner">
                    <p>50 Coffees</p>
                    <p>Per session</p>
                  </span>
                  <p> + Create your own templates</p>
                  <p> + Advanced cupping statistics</p>
                  <p> + Self-brand customization</p>
                  <p> + Schedule cuppings and invite friends</p>
                  <p> + Advanced host tools</p>
                  <div class="f1"></div>
                  <a class="button-1 pricing-2" curp>Coming soon</a>
                </div>  
              </div>
              
              <div class="pricing-plan">
                <div class="pricing-plan-header pricing-3">
                  <p class="pricing-plan-header-name">Enterprise</p>
                  <hr/>
                  <p class="pricing-plan-header-price">Contact Us</p>
                  <p class="pricing-plan-header-subheading">51+ Cuppings</p>
                </div>
                <div class="f1"></div>
                <div class="pricing-plan-box">
                  <span class="pricing-plan-two-liner">
                    <p>Up to 1001+ Cuppers</p>
                    <p>Per cupping</p>
                  </span>
                  <span class="pricing-plan-two-liner">
                    <p>100 Coffees</p>
                    <p>Per session</p>
                  </span>
                  <p>+ Integration support</p>
                  <p>+ Brand customization</p>
                  <p>+ Enterprise Statistics</p>
                  <p>+ Much More</p>
                  <div class="f1"></div>
                  <a href="mailto:vbaranov@cup-wise.com" class="button-1 pricing-3 nodec">Contact Us</a>
                </div>  
              </div>

            </div>


          </div>
          <div class="df fdc jcc aic f3">
          </div>
        </div>
      </div>
      <div class="login-big-text df fdc w100p" v-else-if="$route.query.auth == 'about'">
        About
      </div>
      <div class="login-big-text df fdc w100p" v-else>
        <div class="df splash-hero f1 df fdc aifs">
          <div class="df fdc jcc f2 auth-message-wrapper">
            <h2 class="line-1">Taste coffee<br/>together anywhere</h2>
            <p class="line-2"><span class="highlight">Host cupping events with CupWise</span> and bring your coffees to users in over 80 countries. Learn about your taste from and with like-minded coffee enthusiasts.</p>
<!-- 
            <p class="first-one-liner">
              ☕ Host your own tastings<br/>
              📱 Integrate into your website<br/>
              📊 Your go-to coffee analysis tool!
            </p> -->

            <span class="quote">
              <p class="df">
                <span class="quote-mark">"</span>
                <span class="df fdc quote-text">
                  <span>Conceptually, the potential of CupWise is vast... it‘s possible to challenge and bridge the language gap between coffee professionals and drinkers</span>
                  <span>Barista Magazine, April 2022</span>
                </span>
              </p>
              <!-- <p>https://www.baristamagazine.com/cupwise-takes-virtual-cupping-to-a-whole-new-level</p> -->
            </span>
            <div class="df w100p wraps">
                <a v-if="$store.getters['AUTH.anonUser'] || !$store.getters['AUTH.anonUser'].uid" class="button-1 _button-1 _button-11" @click="addQuery('auth', 'register')">Start As Taster For Free</a>
                <a v-else class="button-1 _button-1 _button-11" @click="goTo('/me')">Get Started</a>
                <!-- <a v-if="$store.getters['AUTH.anonUser'] || !$store.getters['AUTH.anonUser'].uid" class="button-0" @click="goPro()">Go Pro</a>
                <a v-else class="button-0" @click="goTo('/me')">Start Tasting</a> -->
            </div>
            <!-- <p class="convert-line">Host <span class="highlighted-text">live cupping sessions</span></p>
            <p class="convert-line">Create <span class="no-word-break highlighted-text">shared tastings</span></p>
            <p class="convert-line"><span class="no-word-break highlighted-text">Engage</span> your customers</p> -->
            <!-- <div class="f1 df fdc jcc aic previews">
              <p>Previews</p>
            </div> -->
          </div>
          <div class="df fdc jcc aic f3">
          </div>
        </div>
        <hr class="full-line full-line-1 w100p"/>
        <div class="landing-section">
          <div class="landing-section-visual vis-1"></div>
          <div class="landing-section-text">
            <h3>Host realtime cupping sessions with discussion and video</h3>
            <p>CupWise helps bridge the gap between how roasters and consumers think and talk about coffee. Host and join live cupping events. Participate in blind cupping, scoring, live chat and video. See how group scoring and descriptions compare to your expectations.</p>
          </div>
        </div>
        <div class="landing-section flip-landing-section">
          <div class="landing-section-text">
            <h3>Get breakthrough insights</h3>
            <p>CupWise provides the ability to analyze, discuss and rate coffee together in an interactive, fun manner. Unique data like polarization and score change over time gives you insights that you’ve never had before. Plus, because you can create your own scoring templates, you can get the exact feedback that you need!
            </p>
          </div>
          <div class="landing-section-visual vis-2"></div>
        </div>
        <div class="landing-section">
          <div class="landing-section-visual vis-3"></div>
          <div class="landing-section-text">
            <h3>Embedded scoring</h3>
            <p>Embed CupWise scoring directly into your website to get direct product feedback from customers. Use customizable scoring templates to quickly get the information that you need. Whether you host cupping events, sell coffee or are an enthusiast looking for great new coffee, we invite you to find out how to integrate CupWise into your strategy.
            </p>
          </div>
        </div>
        <div class="landing-section df fdc">
          <!-- <div class="landing-section-visual vis-3"></div> -->
          <div class="landing-section-text landing-section-text-alt">
            <h3 class="">Follow what's happening around Cupwise</h3>
            <NewsFeed />
            <!-- <p>... -->
            </p>
          </div>
        </div>
        <div v-if="$store.getters['AUTH.anonUser']" class="full-width df jcc aic w100p">
          <div class="df aic jcsb w100p max">
            <h3>Host cuppings with CupWise</h3>
            <a class="button-4" @click="goPro()">
              Sign Up
            </a>
          </div>
        </div>
        <div v-else class="full-width df jcc aic w100p">
          <div class="df aic jcsb w100p max">
            <h3>Go to the dashboard to start</h3>
            <a class="button-4" @click="goTo('/me')">
              Go
            </a>
          </div>
        </div>
      </div>


      <div class="auth-background" v-if="($route.query.pro == 'get') || ($route.query.auth == 'login') || ($route.query.auth == 'register')" @click="closeMenus($route.query.pro == 'get')">
      </div>
      <div class="login-inputs auth-menu df fdc" v-if="($route.query.pro == 'get')">
        <img src="../../static/images/close-x.svg" @click="addQuery('pro', undefined)" class="close-menu">
        <h4 class="_m2 get-started">Be the first to get Pro!</h4>
        <p class="cupwise"><span>Sign Up to Cup</span>Wise</p>
        <p class="already-have-account-line auth-sub">Sign up to get notified when Cupwise is available.</p>
        <p v-if="emailSubmitted" class="thank-you"><span>Thank you!</span> We will e-mail you soon.</p>
        <p class="login-input-heading" v-if="!emailSubmitted">Email</p>
        <input v-model="email" placeholder="E-mail" type="text" name="" v-if="!emailSubmitted">
        <a class="_m1 button-1 _button-1" @click="submitEmail()" v-if="!emailSubmitted">Submit</a>
      </div>



      <div class="login-inputs auth-menu df fdc" v-if="($route.query.auth == 'register')">
        <img src="../../static/images/close-x.svg" @click="addQuery('auth', undefined, true)" class="close-menu">
        <h4 class="_m2 get-started">Get started as a cupper for free!</h4>
        <p class="cupwise"><span>Sign Up to Cup</span>Wise</p>
        <p class="already-have-account-line auth-sub">Already a member? <a @click="addQuery('auth', 'login')">Log in.</a></p>
        <p class="login-input-heading">Email</p>
        <input v-model="email" placeholder="E-mail" type="text" name="">
        <p class="login-input-heading">Password</p>
        <input placeholder="Password" type="password" v-model="password" name="">
        <p class="login-input-heading">Repeat Password</p>
        <input placeholder="Repeat Password" type="password" v-model="password2" name="">
        <p v-if="error">{{error}}</p>
        <a class="_m1 button-1 _button-1" @click="register()">Register</a>
        <p class="_m3 get-started">Looking to host sessions? <a @click="addQuery('auth', 'pro')">Get a Pro Account!</a></p>
      </div>

      <div class="login-inputs auth-menu df fdc" v-if="($route.query.auth == 'login')">
        <img src="../../static/images/close-x.svg" @click="addQuery('auth', undefined, true)" class="close-menu">
        <h4 class="_m2 get-started">Log in to start cupping!</h4>
        <p class="cupwise"><span>Log In to Cup</span>Wise</p>
        <p class="already-have-account-line auth-sub">Don't have an account? <a @click="addQuery('auth', 'register')">Register here.</a></p>
        <p class="login-input-heading">Email</p>
        <input v-model="email" placeholder="E-mail" type="text" name="">
        <p class="login-input-heading">Password</p>
        <input v-model="password" placeholder="Password" type="password" name="">
        <div class="df w100p jcsb">
        </div>
        <p v-if="error">{{error}}</p>
        <a class="_m1 button-1 _button-1" @click="login()">Login</a>
      </div>

<!--       <div class="login-inputs df fdc" v-if="loginMode == 'password-recovery'">
        <h4>Password Recovery: Enter your email</h4>
        <input type="text" name="">
        <button>Recover Password</button>
      </div> -->
    </div>


  </div>
</template>

<script>

import router from '@/router'
import NewsFeed from '@/components/NewsFeed'

export default {
  name: 'Login',
  data () {
    return {
      checkoutCC: '',
      checkoutCCDate: '',
      checkoutCCCVV: '',
      checkOutOption: true,
      checkOutOptionB: false,
      checkoutError: '',
      getPlanError: '',
      showAuthMenu: false,
      loginMode: 'register',
      loading: false,
      email: '',
      password: '',
      password2: '',
      error: '',
      emailSubmitted: false,
      displayName: '',
      newPassword: '',
      newPasswordConfirm: '',
      checkoutEmail: '',
      otherEmail: '',
      activating: false
    }
  },
  props: [],
  components: {
    NewsFeed
  },
  methods: {
    goPro () {
      this.$router.push('/?auth=pro&pro=getpro')
      window.scrollTo(0,0)
    },
    goTo (path) {
      router.push(path)
      window.scrollTo(0,0)
    },
    getProPlan () {
      let otherEmail = this.otherEmail
      let password = this.newPassword
      let password2 = this.newPasswordConfirm

      if (!this.checkoutCC) {
        this.getPlanError = 'Please input a credit card number.'
        return false
      } else if (!this.checkoutCCDate) {
        this.getPlanError = 'Please input an expiry date.'
        return false
      } else if (!this.checkoutCCCVV) {
        this.getPlanError = 'Please input a CVV number.'
        return false
      } 

      if (password == password2) {
        // validate numbers exist
        this.activating = true
        this.$store.dispatch('AUTH.checkout', {
          number: this.checkoutCC,
          date: this.checkoutCCDate,
          cvv: this.checkoutCCCVV,
          otherEmail,
          password
        }).then((res) => {
          console.log('res', res)
          this.activating = false
          if (res.data && (res.data.status == 500)) {
            if (res.data.code == 'auth/email-already-exists') {

              this.$router.replace({
                query: Object.assign({}, this.$route.query, {
                  nextPath: '/?auth=pro&pro=getpro'
                })
              })
              let nextPath = '/?auth=pro&pro=getpro'
              if (this.$store.getters['AUTH.email']) {
                // router.push('/me?nextPath=' + nextPath)
              } else {
                this.$store.dispatch('AUTH.login', {email: otherEmail, password})
              }

            } else {
              this.getPlanError = res.data.message
            }
            return
            // this.emailSubmitted = true
          } else if (res) {
            this.activating = false
            console.log('log in now')
            if (this.$store.getters['AUTH.email']) {
              router.push('/me')
            } else {
              this.$store.dispatch('AUTH.login', {email: otherEmail, password})
            }
          }
          this.activating = false
          // this.error = ''
        }).catch((err) => {
          console.log('err', err)
          // this.error = err.message
        })
      } else {
        console.log('passwords do not match')
        this.getPlanError = 'Passwords do not match.'
      }

    },
    closeMenus (pro) {
      if (this.$route.query.then) {
        router.push('/live/' + this.$route.query.then)
      } else {
        this.addQuery('auth', pro ? 'pro' : undefined)
        this.addQuery('pro', undefined)
      }
    },
    addQuery (query, param, close) {
      if (this.$route.query.then && close) {
        router.push('/live/' + this.$route.query.then)
      } else {
        this.$router.replace({
          query: Object.assign({}, this.$route.query, {
            [query]: param
          })
        })
        window.scrollTo(0,0)
      }
    },
    login () {
      this.$store.dispatch('AUTH.login', {
        email: this.email,
        password: this.password,
      }).then((res) => {
        this.error = ''
      }).catch((err) => {
        this.error = err.message
      })
    },
    submitEmail () {
      this.$store.dispatch('AUTH.submitEmail', {
        email: this.email,
      }).then((res) => {
        console.log('res', res)
        if (res.message == 'ok') {
          this.emailSubmitted = true
        }
        // this.error = ''
      }).catch((err) => {
        console.log('err', err)
        // this.error = err.message
      })
    },
    register () {
      if (this.password == this.password2) {
        this.$store.dispatch('AUTH.register', {
          // name: this.name,
          anon: this.$store.getters['AUTH.anonUser'],
          email: this.email,
          password: this.password
        }).then((res) => {
        this.error = ''
        }).catch((err) => {
          this.error = err.message
        })
      } else {
        console.log('..')
        this.error = 'The passwords do not match'
      }
    },
    setLoginMode (loginMode) {
      this.loginMode = loginMode
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
    console.log('* Landing page created', this.$route)
    if (this.$route.name == 'ProPage') {
      router.push('/?auth=pro&pro=getpro')
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../styles/settings.scss";

  ._m1 {
    margin-bottom: 8px;
    margin-top: 22px;
  }

  ._m2 {
    margin-bottom: 8px;
  }

  h1 {
    margin-bottom: 30px;
    font-size: 50px;
    max-width: 720px;

    & + p {
      font-size: 24px;
    }
  }

  .login-wrapper {
    /*background-color: #292929;*/
    padding: 30px 60px;
    padding-top: 30px;
    padding-top: 118px;
    padding-top: 168px;
    padding-bottom: 230px;
    background-color: #fff;
  }
  .login-splash {
    width: 100%;
    max-width: 1200px;
    padding: 0;
    /*padding: 85px 90px;*/
    /*border: 1px solid $color-white;*/

    & > div {
      &:first-child {
        /*margin-right: 120px;*/
      }
    }

  }
  .splash-hero {
    height: 250px;
    /*margin-top: 20px;*/
  }
  .login-inputs {
    /*position: absolute;*/
    /*top: 0;*/
    /*right: 60px;*/
    padding-top: 20px;
    width: 200px;
    font-size: 12px;

    input {
      border: none;
      height: 40px;
      width: 100%;
      max-width: 390px;
      border-radius: 2px;
      background-color: #F3F3F5;
    }
  }
  .convert-line {
    margin-bottom: 4px;
    font-weight: 300;
    /*font-family: "Nexa";*/
    font-size: 28px;

    &:last-of-type {
      margin-bottom: 0;
    }

    span {
      /*font-family: "Nexa";*/
      font-weight: 600 !important;
    }
  }
  .already-have-account-line {
    margin-bottom: 6px;

    span {
      cursor: pointer;
      text-decoration: underline;
      color: #5469d4;
    }
  }
  .no-word-break {
    white-space: nowrap;
    /*white-space: none;*/
  }
  .convert-line {
    .highlighted-text {
      font-weight: 600 !important;
      span {
        font-weight: 600 !important;
      }
      color: #5469d4;
    }
  }
  .previews {
    /*margin-bottom: 20px;*/
  }

  .cupwise-logo {
    width: 110px;
  }

  .beta {
    /*margin-left: 20px;*/
  }

  .auth-background {
    z-index: 100;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    position: fixed;
    background-color: rgba(0,0,0,0.5);
  }

  .auth-menu {
    background-color: white;
    border-radius: 5px;
    z-index: 200;
    top: 100px;
    left: 50%;
    width: calc(100% - 90px);
    max-width: 690px;
    padding: 60px 90px;
    /*position: fixed;*/
    position: absolute;
    transform: translate(-50%, 0);
  }

  .dn {
    display: none;
  }

  @media (max-height: 828px) {
    .auth-menu {
      top: 25px;
    }
  }

  @media (max-width: 750px) {
    .auth-menu {
      padding-left: 60px;
      padding-right: 60px;
    }
  }

  @media (max-width: 550px) {
    .auth-menu {
      padding: 40px;
      width: 100%;
      /*width: calc(100% - 50px);*/
      border-radius: 0;
      padding-left: 40px;
      padding-right: 40px;
      /*padding: 30px 40px;*/
    }
    .pricing-plans {
      width: 100%;
    }
    .pricing-plan-single {
      padding-left: 15px;
      padding-right: 15px;
    }
    .pricing-plan-2 {
      width: 100%;
      max-width: 325px;
    }
  }

  @media (max-width: 450px) {
    .auth-menu {
      padding-left: 20px;
      padding-right: 20px;
      /*padding: 20px 20px;*/
    }
  }

  .cupwise {
    color: #000000;
    font-family: Inter;
    font-size: 48px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 59px;

    span {
      font-weight: 700;
    }
  }

  .auth-sub {
    /*color: #27C8B3;*/
    font-family: Inter;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 20px;
    margin-top: 16px;
  }

  a {
    color: $color-primary;
    font-weight: bold;
  }

  .get-started {
    font-family: Inter;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 20px;
  }

  .login-input-heading {
    color: #49494C;
    font-family: Inter;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 17px;
    margin-bottom: 13px;
    margin-top: 22px;

    &:first-of-type {
      margin-top: 16px;
    }
  }

  ._button-1 {
    max-width: 163px;
  }

  /*@*/
  ._button-11 {
    max-width: unset;
  }

  .close-menu {
    position: absolute;
    top: 12px;
    right: 15px;
    cursor: pointer;
  }

  .line-1 {
    color: #000000;
    font-family: Inter;
    font-size: 48px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 59px;
  }

  .line-2 { 
    color: #000000;
    font-family: Inter;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    margin-top: 16px;
    margin-bottom: 24px;

    .highlight {
      color: #27C8B3;
      font-size: 20px;
      font-weight: 500;
    }
  }

  .line-3 {
    color: #000000;
    font-family: Inter;
    font-size: 32px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 39px;
    margin-bottom: 8px;
  }

  .auth-message-wrapper {
    width: 100%;
    max-width: 510px;
  }

  ._m3 {
    margin-top: 22px;
  }

  ._m4 {
    margin-bottom: 25px;
  }

  .nodec {
    text-decoration: none;
  }

  .thank-you {
    margin-top: 30px;
    font-size: 20px;
    span {
      color: $color-primary;
    }
  }

  .full-line {
    width: 100%;
    height: 1px;
    background-color: #979797;
  }

  .full-line-1 {
    margin-top: 105px;
    margin-bottom: 57px;
  }

  @media (max-width: 1000px) {
    .full-line-1 {
      margin-top: 80px;
    }
    .login-wrapper {
      /*padding-top: 165px;*/
    }
  }
  @media (max-width: 620px) {
    .login-wrapper {
      padding-top: 120px;
    }
  }
  @media (max-width: 580px) {
    .full-line-1 {
      margin-top: 60px;
    }
  }
  @media (max-width: 480px) {
    h2.line-1 {
      font-size: 40px;
      line-height: 40px;
    }
  }


  .landing-section {
    display: flex;
    justify-content: space-between;
    margin-bottom: 57px;

    &-text {
      height: 100%;
      flex: 1;
      height: 547px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-left: 90px;
      margin-bottom: 20px;

      h3 {
        width: 100%;
        color: #000000;
        font-family: Inter;
        font-size: 32px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 39px;
        margin-bottom: 9px;
        text-align: left;
      }

      p { 
        color: #000000;
        font-family: Inter;
        font-size: 16px;
        letter-spacing: 0;
        line-height: 20px;
        text-align: left;
      }
    }

    &-visual {
      width: 538px;
      /*width: 100%;*/
      height: 547px;
      /*border: 1px solid #27C8B3;*/
      border-radius: 10px;
      background-size: cover;
    }

    &:nth-of-type(odd) {
      .landing-section-text {
        margin-left: 0;
        margin-right: 90px;
      }
    }

    .landing-section-text-alt {
      margin-top: 20px;
      flex: 1;
      flex-direction: column;
      align-items: flex-start;
      h3 {
        font-size: 32px !important;
        margin-bottom: 30px;
        /*text-align: center;*/
      }
    }

    @media (max-width: 1160px) {
      .landing-section-visual {
        width: 392px;
        height: 400px;
      }
      .landing-section-text {
        height: 400px;
        h3 {
          font-size: 28px;
          line-height: 34px;
        }
      }
    }

    @media (max-width: 975px) {
      .landing-section-visual {
        width: 270px;
        height: 275px;
      }
      .landing-section-text {
        height: 270px;
        margin-left: 60px;
      }


      &:nth-of-type(odd) {
        .landing-section-text {
          margin-left: 0;
          margin-right: 60px;
        }
      }
    }

  }
  @media (max-width: 768px) {
    .landing-section {
      flex-direction: column;
      align-items: center;

      .landing-section-visual {
        width: 370px;
        width: 100%;
        height: 375px;
      }
      .landing-section-text {
        text-align: center;
        height: 270px;
        margin-left: 0px;
        margin-top: 30px;
      }

      &:nth-of-type(odd) {
        .landing-section-text {
          /*margin-left: 0;*/
          margin-right: 0px;
        }
      }
    }
    .flip-landing-section {
      flex-direction: column-reverse;
    }
  }
  @media (max-width: 480px) {
    .login-wrapper {
      padding-left: 30px;
      padding-right: 30px;
    }
    .landing-section {
      align-items: center;
      height: unset;

      .landing-section-visual {
        /*margin-top: 20px;*/
        width: 270px;
        width: 100%;
        height: 270px;
      }
    }
  }

  @media (max-width: 380px) {
    .login-wrapper {
      /*padding-left: 15px;*/
      /*padding-right: 15px;*/
    }
  }

  .full-width {
    width: 100%;
    height: 137px;
    background-color: $color-primary;
    position: absolute;
    bottom: 90px;
    left: 0;
  }

  @media (max-width: 768px) {
    .full-width {
      bottom: 200px;
    }
  }

  .max {
    max-width: 1200px;
    padding-left: 60px;
    padding-right: 60px;

    h3 {
      color: #FFFFFF;
      font-family: Inter;
      font-size: 32px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 39px;
    }
  }

  @media (max-width: 568px) {
    .full-width {
      height: 250px;
    }
    .max {
      padding-left: 30px;
      padding-right: 30px;
      h3 {
        text-align: center;
        font-size: 26px;
        margin-bottom: 20px;
      }
      flex-direction: column;
    }
    .login-wrapper {
      padding-bottom: 300px;
    }
  }

  .vis-1 {
    background-image: url('../../static/images/post-1-d.jpg');
    background-position: 25% center;
    background-size: fill;
  }
  .vis-2 {
    background-image: url('../../static/images/post-2-d.jpg');
  }
  .vis-3 {
    background-image: url('../../static/images/post-3-b.png');
  }

  .checkout {
    max-width: 420px;
    flex: 1;
    /*margin-right: 124px*/
  }

  .getting-pro {
    background-color: #f7f8f9;
  }

  .checkout-input {
    border-radius: 2px;
    background-color: white;
    border: none;
    font-family: Inter;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 15px;
  }

  .cc-card {

  }
  .cc-date {

  }
  .cc-cvv {

  }

  .checkout-line {
    width: 100%;
    height: 1px;
    background-color: #979797;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .mw870 {
    max-width: 870px;
  }

  .payment-methods {
    margin-bottom: 12px;
  }


  .one-payment-method {
    img {
      height: 16px;
      margin-left: 5px;
      margin-right: 10px;
    }
    p {
      font-family: Inter;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 17px;
    }

    &:first-child {
      margin-right: 90px;
    }
  }

  .checkout-protection {
    margin-top: 26px;
    color: #5C5C5C;
    font-family: Inter;
    font-size: 10px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 12px;
  }

  .checkout-button {
    margin-top: 16px;
  }

  .card-error {
    height: 70px;
    background-color: #FFF7D4;
    margin-bottom: 26px;

    .warning {
      width: 50px;
      height: 70px;
      background-color: #FFDA4B;
    }

    .card-error-message {
      padding-left: 15px;
      padding-right: 15px;

      p {
        color: #000000;
        font-family: Inter;
        font-size: 12px;
        letter-spacing: 0;
        line-height: 15px;

        &:first-child {
          font-weight: 700;
        }
      }
    }

  }


  .check-fulfillment {
    margin-right: 15px;

    input {
      width: 20px;
    }
  }
.check-fulfillment {
  position: relative;
}

.check-fulfillment label {
  border-radius: 50%;
  cursor: pointer;
  left: 0;
  position: absolute;
  top: 0;
  height: 18px;
  width: 18px;
  border: 1px solid #5C5C5C;
  background-color: #F3F3F5;
}

.check-fulfillment label:after {
  content: " ";
  height: 10px;
  width: 10px;
  background-color: #27C8B3;
  left: 3px;
  border-radius: 50%;
  opacity: 0;
  position: absolute;
  top: 3px;
  /*transform: rotate(-45deg);*/
}

.check-fulfillment input[type="checkbox"] {
  visibility: hidden;
}

.check-fulfillment input[type="checkbox"]:checked + label {
  /*background-color: #66bb6a;*/
  /*border-color: #66bb6a;*/
}

.check-fulfillment input[type="checkbox"]:checked + label:after {
  opacity: 1;
}


.quote {
  display: flex;
  flex-direction: column;
  /*align-items: center;*/
  margin-bottom: 30px;

  &-mark {
    font-size: 50px;
    font-weight: 600;
    color: $color-primary;
    font-family: Inter;
    margin-right: 10px;
  }

  &-text {
    padding-right: 20px;
    span {
      &:first-child {
        max-width: 370px;
        font-size: 14px;
        margin-bottom: 10px;
      }
      &:last-child {
        font-size: 12px;
      }
    }
  }

  p {
    font-family: Inter;
    background-color: #F2F2F2;
    border-radius: 8px;
    padding: 16px 19px;
  }
}


  .check-fulfillment-box {
    display: flex;
    height: 20px;
    margin: 0;
  }

  .mb20 {
    margin-bottom: 20px;
  }

  ._s1 {
    margin-top: 2px;
    margin-bottom: 0px !important;
  }

  .checkout-price {
    color: #27C8B3;
    font-family: Inter;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 29px;
    text-align: center;
  }

  .checkout-price-2 {
    text-align: left;
  }

  .checkout-price-next {
    margin-left: 10px;
    p {
      color: #000000;
      font-family: Inter;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 17px;
    }
  }

  ._s2_1 {
    margin-right: 11px;
  }

  ._s2_2 {
    margin-left: 11px;
  }

  .per-month {
    font-size: 12px !important;
    line-height: 12px !important;
  }

  .cc-icon {
    margin-right: 8px;
  }

  .cc-inputs {
    margin-bottom: 10px;
  }

  .get-plan-error {
      background-color: #FFDA4B;
      padding: 5px;
      border-radius: 5px;


      padding-left: 15px;
      padding-right: 15px;
      color: #000000;
      font-family: Inter;
      font-size: 12px;
      letter-spacing: 0;
      line-height: 15px;

      &:first-child {
        font-weight: 700;
      }
  }

  .stripe-lock {
    margin-right: 8px;
  }

  .get-cupwise {
    margin-bottom: 10px;
    font-family: 'Roboto';
    font-size: 26px;

    .ull {
      text-decoration: underline;
      margin-bottom: 10px;
      font-family: 'Roboto';
      font-size: 26px;
    }
  }

  .highlighted-plan {
    box-shadow: 0px 0px 1px 2px #27C8B3;
  }

  .first-one-liner {
    display: block;
    line-height: 22px;
    /*margin-top: 45px;*/
    /*font-weight: 600;*/
    font-size: 14px;
  }


  @media (max-width: 1050px) {
    .splash-hero-2 > div {
      flex-direction: column;
      align-items: center;
    }
    .one-liner-upgrade {
      display: block;
      margin-top: 45px;
      font-weight: 600;
      font-size: 16px;

      margin-top: 50px !important;
      margin-bottom: 30px;
    }


    .one-liner-upgrade {
      font-family: Inter;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 17px;
      margin-top: 17px;
      max-width: 420px;
    }
    .first-one-liner {
      /*display: none;*/            
    }

    .pricing-plan-2 {
      margin-top: 30px !important;
    }
  }

  @media (max-width: 570px) {
    .wraps {
      flex-direction: column;
      .button-0 {
        margin-top: 5px;
      }
    }
  }



</style>



// WEBPACK FOOTER //
// src/pages/Login.vue